import { apiClient } from '../services/api-client';

/**
 * POSTs a new FHIR resource through the `/fhir` proxy.
 *
 * The response is unvalidated JSON, so `TResource` is an unchecked claim confined
 * to this boundary rather than validation — see the longer note in `FHIRFetcher`.
 * It defaults to `fhir4.Resource` because FHIR's `create` interaction answers with
 * the persisted resource, and the call sites create several unrelated types
 * (`CommunicationRequest`, `Communication`, `Task`).
 *
 * `data` is `unknown` for the same reason given on `FHIRUpdater`.
 */
const FHIRPoster = async <TResource = fhir4.Resource>(
  endPoint: string,
  token: string,
  data: unknown,
): Promise<TResource> => {
  const dataEndPoint = '/fhir' + endPoint;
  const result = await apiClient.post<TResource>('fhir-proxy', dataEndPoint, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: data,
  });
  return result;
};
export default FHIRPoster;
